import React from 'react';

import { ActionIcon, Group, Menu, px, useMantineTheme } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { IconDotsVertical } from '@tabler/icons-react';
import { AppointmentCoachRole } from 'types';

import ModalDeleteAppointmentCoachRole from './ModalDeleteAppointmentCoachRole';
import ModalEditAppointmentCoachRole from './ModalEditAppointmentCoachRole';

interface IAppointmentCoachRoleTableHeaderProps {
  permission?: boolean;
  role: AppointmentCoachRole;
}

const AppointmentCoachRoleTableHeader = ({
  role,
  permission = true,
}: IAppointmentCoachRoleTableHeaderProps): JSX.Element => {
  const theme = useMantineTheme();
  const [editModalOpened, { open: openEditModal, close: clodeEditModal }] = useDisclosure(false);
  const [deleteModalOpened, { open: openDeleteModal, close: closeDeleteModal }] = useDisclosure(false);

  return (
    <th
      key={role.appointmentCoachRoleId}
      style={{ width: `${px(theme.spacing.xl) * 10}px`, background: theme.colors.gray[1] }}
    >
      <Group position='apart'>
        {role.name}
        <Menu position='bottom-end'>
          <Menu.Target>
            <ActionIcon
              data-cy='actionAppointmentCoachRoleButton'
              variant='subtle'
              onClick={(e: React.MouseEvent<HTMLButtonElement>) => e.stopPropagation()}
              disabled={!permission}
            >
              <IconDotsVertical size={theme.fontSizes.md} fill={theme.white} />
            </ActionIcon>
          </Menu.Target>
          <Menu.Dropdown>
            <Menu.Item onClick={openEditModal}>Edit</Menu.Item>
            <Menu.Item onClick={openDeleteModal}>Delete</Menu.Item>
          </Menu.Dropdown>
        </Menu>
      </Group>
      <ModalEditAppointmentCoachRole
        opened={editModalOpened}
        handleClose={clodeEditModal}
        appointmentCoachRole={role}
      />
      <ModalDeleteAppointmentCoachRole
        opened={deleteModalOpened}
        handleClose={closeDeleteModal}
        appointmentCoachRoleId={role.appointmentCoachRoleId}
      />
    </th>
  );
};

export default AppointmentCoachRoleTableHeader;
